<template>
  <!-- 开始考试 -->
  <el-dialog title="历史记录"
             :visible.sync="dialogVisible2"
             width="60%">
    <div>
      <div>
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <el-form-item label="关键字">
            <el-input v-model="formInline.key"
                      placeholder="请输入关键字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="onSubmit">查询</el-button>
            <el-button type=""
                       @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table :data="tabData"
                  border
                  style="width: 100%">
          <el-table-column type="index"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           label="老师姓名"
                           align="center"
                           width="120">
          </el-table-column>
          <el-table-column prop="name"
                           label="考试时间"
                           align="center">
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           align="center"
                           width="120">
            <template slot-scope="scope">
              <el-button size="mini"
                         @click="handleStart(scope.$index, scope.row)"
                         type="primary">查看成绩</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px;">
          <el-pagination layout="prev, pager, next"
                       :total="total"
                       :page-size="pamas.pageSize"
                       @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle">
        </el-pagination>
        </div>
      </div>
      <div style="display:flex;justify-content: flex-end;margin-top:15px;">
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <!-- <el-button type="primary"
                     @click="dialogVisible2 = false">确 定</el-button> -->
        </span>
      </div>

    </div>
  </el-dialog>
</template>
<script>
import { format } from "@/utils/datetime"
import uploadExam from "@/components/UploadExam"
export default {
  components: {
    uploadExam
  },
  data () {
    return {
      dialogVisible2: false,
      formInline: {
        key:""
      },
      total: 0,
      pamas: {
        examId: "",
        pageNum: 1,
        pageSize: 10
      },
      tabData: [],
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible2 = true
    },
    getHistoryScoreList(){

    },
    pageSizeChangeHandle (val) {
      this.pamas.pageSize = val;
      this.pamas.pageNum = 1;
    },
    pageCurrentChangeHandle (val) {
      this.pamas.pageNum = val;
      this.getHistoryScoreList()
    },
    onReset(){
      this.pamas.pageNum = 1;
      this.pamas.pageSize =10;
      this.formInline.key="";
      this.getHistoryScoreList()
    },
    onSubmit(){
     this.getHistoryScoreList()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ExamCenter/components/HistoryScore.vue